/**
 * Fallback labels.
 *
 * The authoritative bundle is served by the API (`GET /api/v1/labels/{locale}`)
 * and includes any terminology an administrator has customised. These entries
 * are only used before that response arrives - on the sign-in screen, on a cold
 * load, or if the API is briefly unreachable - so they cover the chrome rather
 * than every string.
 *
 * English is the only language shipped today. To add another language later,
 * add its code to LOCALES and a fallback block here; the rest of the pipeline
 * (bundle fetch, overrides, caching) is already per-locale.
 */

export type LabelMap = Record<string, string>;

export const FALLBACK_LABELS: Record<string, LabelMap> = {
  en: {
    "nav.dashboard": "Dashboard",
    "nav.inbox": "My tasks",
    "nav.requests": "Test requests",
    "nav.reception": "Sample reception",
    "nav.confirmations": "Sample confirmations",
    "nav.handovers": "Sample hand-over",
    "nav.disposal": "Sample disposal",
    "nav.samples": "Samples",
    "nav.worklist": "Worklist",
    "nav.bench_binder": "Bench binder",
    "nav.certificates": "Certificates",
    "nav.equipment": "Equipment",
    "nav.monitoring": "Monitoring logs",
    "nav.inventory": "Store & reagents",
    "nav.documents": "Documents & SOPs",
    "nav.worksheet_templates": "Worksheet templates",
    "nav.worksheet_runs": "Worksheets",
    "nav.validation": "Method validation",
    "nav.outsourcing": "Outsourced analyses",
    "nav.retests": "Retests",
    "nav.external_labs": "External laboratories",
    "nav.clients": "Clients",
    "nav.feedback": "Customer feedback",
    "nav.catalog": "Test catalogue",
    "nav.registers": "Registers",
    "nav.departments": "Departments",
    "nav.instruments": "Instrument data",
    "nav.connections": "Connections",
    "nav.reports": "Reports",
    "nav.admin": "Administration",
    "action.save": "Save",
    "action.cancel": "Cancel",
    "action.approve": "Approve",
    "action.reject": "Reject",
    "action.return": "Return for correction",
    "action.new_request": "New test request",
    "message.no_tasks": "Nothing is waiting for you.",
    "message.no_results": "No records match these filters.",
    "workflow.timeline": "Approval trail",
  },
};

export const LOCALES = [{ code: "en", label: "English", short: "EN" }] as const;

export type LocaleCode = (typeof LOCALES)[number]["code"];

export const DEFAULT_LOCALE: LocaleCode = "en";
